module.exports = __webpack_public_path__ + "img/miral-roast-package.26e79694.webp";